
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BASEURL";
export default function TestimonialsCMS() {
  const navigate = useNavigate();
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTestimonials = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${BASE_URL}/api/testimonial`);
        if (!res.ok) throw new Error("Failed to fetch testimonials");
        const json = await res.json();
        setTestimonials(Array.isArray(json.data) ? json.data : []);
      } catch (err) {
        setError(err.message || "Failed to fetch testimonials");
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonials();
  }, []);

  if (loading) return <p className="p-10">Loading...</p>;
  if (error) return <p className="p-10 text-red-500">{error}</p>;

  return (
    <div className="max-w-7xl mx-auto md:p-6">
      <div className="flex justify-between items-start md:items-center gap-3 mb-6 flex-col md:flex-row">
        <h1 className="text-2xl font-bold text-primaryDark">Client Testimonials</h1>
        <button
          onClick={() => navigate("/admin/addtestimonial")}
          className="bg-primary text-white px-6 py-2 rounded hover:bg-primaryDark"
        >
          + Add Testimonial
        </button>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {testimonials.length === 0 && <p className="p-10">No testimonials found.</p>}
        {testimonials.map((item) => (
          <div
            key={item.id || item._id || item.name}
            className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition"
          >
            <p className="text-gray-700 italic mb-4">"{item.message}"</p>
            <h4 className="font-semibold text-primary">{item.name}</h4>

            <div className="flex gap-3 mt-4">
              <button className="text-sm border border-red-500 text-red-500 px-4 py-1 rounded hover:bg-red-500 hover:text-white transition">
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
